import { MESSAGE_TYPE_MAP } from 'shared/consts/consts';
import { IEmailAttachmentsData, IObjProps } from 'shared/consts/types';
import { downloadData } from 'shared/helpers';
import Download from 'shared/icons/EmailImgDownload.svg';

import { i18nHelper } from 'i18nHelper';

export const emailComponentCss = {
	textAlign: 'left',
	paddingTop: '1rem',
	paddingRight: '1rem',
	paddingBottom: '1rem',
	paddingLeft: '1rem',
	marginTop: '0.5rem',
	marginBottom: '0.5rem',
	borderTopRightRadius: '0.5rem',
	borderTopLeftRadius: '0.5rem',
	borderBottomRightRadius: '0.5rem',
	borderBottomLeftRadius: '0.5rem',
	maxWidth: '100%',
	overflow: 'auto',
};

export const jumpToLatestCss = {
	display: 'flex',
	justifyContent: 'space-between',
	minWidth: '6.5rem',
	alignItems: 'middle',
	position: 'absolute',
	bottom: '1rem',
	left: '50%',
	transform: 'translate(-50%, 20%)',
	cursor: 'pointer',
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
	paddingLeft: '1.5rem',
	paddingRight: '1.5rem',
	paddingTop: '0.5rem',
	paddingBottom: '0.5rem',
	borderTopRightRadius: '5rem',
	borderTopLeftRadius: '5rem',
	borderBottomRightRadius: '5rem',
	borderBottomLeftRadius: '5rem',
};

export const getCloseEmailThreadIcon = (fill: string) =>
	`<svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6 1H2.4C1.6268 1 1 1.6268 1 2.4V5.2C1 5.9732 1.6268 6.6 2.4 6.6H13.6C14.3732 6.6 15 5.9732 15 5.2V2.4C15 1.6268 14.3732 1 13.6 1Z" stroke="${fill}" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M4.80078 3.80005H4.80878" stroke="${fill}" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 3.80005H8.008" stroke="${fill}" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M11.1992 3.80005H11.2072" stroke="${fill}" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>`;

export const togglePreviousEmail = (state: string, bodyRef: any) => {
	if (bodyRef.current) {
		const element: HTMLElement = bodyRef.current.getElementsByClassName('gmail_quote')[0];
		if (element) {
			element.style.display = state;
		}
	}
};

export const toggleCloseEmailThreadIcon = (state: string, bodyRef: any) => {
	if (bodyRef.current) {
		const element: HTMLElement = bodyRef.current.getElementsByClassName('hide-email-thread')[0];
		if (element) {
			element.style.display = state;
		}
	}
};

export const processUserEmailBody = (bodyRef: any, theme: any, setShowPreviousMail: any) => {
	const thread = bodyRef.current.children[0].getElementsByClassName('gmail_quote') || [];

	if (thread && thread[0]) {
		const ellipsis = document.createElement('div');
		ellipsis.innerHTML = getCloseEmailThreadIcon(theme.text);
		ellipsis.classList.add('hide-email-thread');
		ellipsis.style.display = 'none';
		ellipsis.addEventListener('click', () => {
			togglePreviousEmail('none', bodyRef);
			setShowPreviousMail(false);
			toggleCloseEmailThreadIcon('none', bodyRef);
		});
		thread[0].parentNode.insertBefore(ellipsis, thread[0]);
	}
};

export const processAgentEmailBody = (bodyRef: any, theme: any, setShowPreviousMail: any, getDownloadUrl: any) => {
	const imgNodes: Array<any> = [];
	const children = bodyRef.current.children[0].children || [];

	let emailThreadIndex = -1;
	for (let i = 0; i < children.length; i++) {
		if (children[i].classList.contains('gmail_quote')) {
			emailThreadIndex = i;
			continue;
		}
		const images = children[i].querySelectorAll('img') || [];
		for (let j = 0; j < images.length; j++) {
			imgNodes.push(images[j]);
		}
	}

	if (emailThreadIndex >= 0) {
		const ellipsis = document.createElement('div');
		ellipsis.innerHTML = getCloseEmailThreadIcon(theme.text);
		ellipsis.classList.add('hide-email-thread');
		ellipsis.style.display = 'none';
		ellipsis.addEventListener('click', () => {
			togglePreviousEmail('none', bodyRef);
			setShowPreviousMail(false);
			toggleCloseEmailThreadIcon('none', bodyRef);
		});
		bodyRef.current.children[0].insertBefore(ellipsis, children[emailThreadIndex]);
	}

	Array.isArray(imgNodes) &&
		imgNodes.forEach((image: any) => {
			const { parentNode } = image;

			image.style.maxWidth = '18.75rem';
			image.loading = 'lazy';

			if (parentNode) {
				const downloadUrl = getDownloadUrl(image.src);
				const previewUrl = image.src;
				if (downloadUrl) {
					const wrapper = document.createElement('div');
					wrapper.classList.add('img-wrapper');

					parentNode.replaceChild(wrapper, image);
					wrapper.appendChild(image);

					const downloadWrapper = document.createElement('div');
					const label = document.createElement('div');
					label.classList.add('download-label');
					label.innerText = i18nHelper('components:emailMessagesPreview.downloadImage');
					const icon = document.createElement('img');
					icon.src = Download;
					const iconWrapper = document.createElement('div');
					iconWrapper.classList.add('icon-wrapper');
					iconWrapper.appendChild(icon);

					downloadWrapper.appendChild(iconWrapper);
					downloadWrapper.appendChild(label);
					wrapper.appendChild(downloadWrapper);
					downloadWrapper.classList.add('img-download');

					wrapper.addEventListener('mouseenter', (event: any) => {
						event.target.classList.add('img-download-toggle');
					});

					wrapper.addEventListener('mouseleave', (event: any) => {
						event.target.classList.remove('img-download-toggle');
					});

					wrapper.addEventListener('click', (event: any) => {
						if (event.target.parentElement && event.target.parentElement.className !== 'icon-wrapper') {
							window.open(previewUrl, '_blank');
						}
					});

					iconWrapper.addEventListener('click', (event: any) => {
						downloadUrl && downloadData(downloadUrl);
					});
				}
			}
		});
};

export const getEmailSubject = (message: IObjProps) => {
	const { messagetype } = message;
	const { emailReceived: EMAIL_RECEIVED, email: EMAIL } = MESSAGE_TYPE_MAP;
	let subject = '';
	if (messagetype === EMAIL_RECEIVED) {
		subject = message.emailData.subject;
	} else if (messagetype === EMAIL) {
		subject = message.emailNotificationData.placeholders.subject;
	}

	return subject;
};

export const setInlineImages = (body: any, inlineContent: Array<IEmailAttachmentsData>) => {
	const attachmentURLs = inlineContent.map((attachment) => attachment.attachmentURL);
	const newBody = new DOMParser().parseFromString(body, 'text/html');
	const images = newBody.querySelectorAll('img');
	for (let i = 0, len = Math.min(images.length, attachmentURLs.length); i < len; i++) {
		images[i].src = attachmentURLs[i];
	}

	return newBody.body.innerHTML;
};
